<template>
  <v-container
    id="user-profile"
    fluid
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
        md="12"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">
              Редактирование клиента
            </div>
          </template>

          <v-form>
            <v-container class="py-0">
              <v-row>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="Имя"
                    class="purple-input"
                    v-model="guest.first_name"
                    :error-messages="errors['first_name'] || []"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="Фамилия"
                    class="purple-input"
                    v-model="guest.last_name"
                    :error-messages="errors['last_name'] || []"
                  />
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    label="Email"
                    class="purple-input"
                    v-model="guest.email"
                    :error-messages="errors['email'] || []"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    label="Телефон"
                    class="purple-input"
                    v-model="guest.phone"
                    :error-messages="errors['phone'] || []"
                  />
                </v-col>
                <v-textarea
                  name="input-7-1"
                  filled
                  label="Примечания"
                  auto-grow
                  v-model="guest.notes"
                ></v-textarea>
              </v-row>
            </v-container>
          </v-form>
          <div class="text-right">
            <v-btn @click="saveProfile" :loading="loading" class="ma-2" tilte   color="success" dark>Сохранить</v-btn>
          </div>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
  export default {
    props : {
      id : {
        type : [String, Number]
      }
    },
    mounted() {
      this.$store.dispatch('guest/getGuest', {
        id : this.id
      })
        .then((data) => {
          this.guest = data;
        })
        .catch(e => console.log(e))
    },
    data(){
      return {
        errors : [],
        loading: false,
        guest : {
          first_name : '',
          last_name : '',
          email : '',
          phone : '',
          notes : ''
        }
      }
    },
    methods:{
      saveProfile(){
        let data = this.guest;
        this.errors = [];
        this.loading = true;
        bus.$emit('onProgressLinear');
        this.$store.dispatch('guest/update', data).then(({data}) => {
          bus.$emit('notificationAlert',{
            text : 'Сохранение прошло успешно',
            color: '#3d97f3'
          });
          bus.$emit('offProgressLinear');
          this.loading = false;
        }).catch((error) => {
          bus.$emit('notificationAlert',{
            text : 'Возникли ошибки',
            color: '#e35351'
          });
          this.loading = false;
          bus.$emit('offProgressLinear');
          let response = error.response

          if(response.status == 422){
            this.errors = response.data.errors;
          }
        });
      }
    }
  }
</script>
